import * as React from "react";
import { forwardRef, memo } from "react";
const SvgRight = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 8 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: props.className, ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 13L7 7L1 1", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgRight);
const Memo = memo(ForwardRef);
export default Memo;
